<template>
  <vue-good-table
  @on-row-click="viewTicket"
  :columns="columns"
  :rows="rows"
  :row-style-class="trClass"
  :paginationOptions="{
    enabled: true,
    perPage: 10,
    position: 'top',
    perPageDropdown: [5, 8, 10, 25, 50],
    dropdownAllowAll: false,
    nextLabel: 'següent',
    prevLabel: 'anterior',
    rowsPerPageLabel: 'Files per pàgina',
    ofLabel: 'de',
    allLabel: 'Tots',
  }"
  :sortOptions="{
    initialSortBy: {field: 'data_creacio', type: 'desc'}
  }">
  <div slot="table-actions" class="mr-2">
    <v-select multiple v-model="other_filters"
    style="min-width: 300px"
      placeholder="-- Altres filtres --"
      :options="!this.isNullOrUndefined(this.other_filters) ? this.filter_options.filter(option => !this.other_filters.includes(option)) : this.filter_options"/>
  </div>
  <div slot="emptystate">
    No tens cap incidència pendent de solucionar
    <font-awesome-icon :icon="['fas', 'check']"/>
  </div>
    <template slot="table-row" slot-scope="props">
      <span v-if="['usuaris','gestors'].includes(props.column.field)" >
        <span>
          {{ props.row[props.column.field].join(", ") }}
        </span>
      </span>
      <span v-else-if="['categoria','grup','incidencia'].includes(props.column.field)" :title="props.row.categoria.descripcio">
          {{ props.row[props.column.field]|truncate(30) }}
      </span>
      <span v-else-if="props.column.field == 'estat'" :title="props.row.estat.nom">
          {{ props.row.estat.nom }}
      </span>
      <span v-else :title="props.row[props.column.field]">
        {{ props.row[props.column.field]|truncate(60) }}
      </span>
    </template>
  </vue-good-table>
</template>

<script>

export default {
  props: {
    table_rows: {
      required: true,
      type: Array
    },
    states: {
      required: true,
      type: Array
    },
    priorities: {
      required: true,
      type: Array
    },
    other_filters: {
      required: true,
      type: Array
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  filters: {
    truncate: function (value, limit) {
      if (value && value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...'
      }
      return value
    }
  },
  watch: {
    states: function (newVal) {
      this.columns[10].filterOptions.filterDropdownItems = newVal
    },
    priorities: function (newVal) {
      this.columns[9].filterOptions.filterDropdownItems = newVal
    },
    table_rows: function (newVal) {
      this.rows = newVal
    },
    other_filters: function (newVal) {
      if (Array.isArray(newVal) && newVal.length === 0) {
        this.other_filters = null
        this.rows = this.table_rows
      } else if (!this.isNullOrUndefined(newVal)) {
        this.other_filters = newVal
        if (!newVal.includes('Suprimir duplicades o descartades')) {
          this.rows = this.table_rows
          if (newVal.includes('Veure només les que gestiono')) {
            this.rows = this.table_rows.filter(row => row.gestors.includes(this.user.id))
          }
        } else {
          this.rows = this.rows.filter(row => !['Descartada', 'Duplicada'].includes(row.estat.nom))
        }
        if (!newVal.includes('Veure només les que gestiono')) {
          this.rows = this.table_rows
          if (newVal.includes('Suprimir duplicades o descartades')) {
            this.rows = this.table_rows.filter(row => !['Descartada', 'Duplicada'].includes(row.estat.nom))
          }
        } else {
          this.rows = this.rows.filter(row => row.gestors.includes(this.user.id))
        }
      }
    }
  },
  methods: {
    trClass: function (row) {
      return row.estat.color + ' text-nowrap'
    },
    filterState: function (data, filterString) {
      return data.nom === filterString
    },
    viewTicket: function (params) {
      this.$router.push({ name: 'TicketPage', params: { 'id': params.row.id } })
    }
  },
  data () {
    return {
      filter_options: ['Veure només les que gestiono', 'Suprimir duplicades o descartades'],
      rows: [],
      columns: [
        {
          label: 'Id',
          field: 'id',
          type: 'number',
          width: '5px',
          tdClass: 'font-weight-bold bg-light',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Id' // placeholder for filter input
          }
        },
        {
          label: 'Detalls',
          field: 'detalls',
          type: 'string',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Usuaris',
          field: 'usuaris',
          type: 'array',
          width: '100px',
          html: false,
          sortable: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Categoria',
          field: 'categoria',
          type: 'string',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Subcategoria',
          field: 'grup',
          type: 'string',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Incidencia',
          field: 'incidencia',
          type: 'string',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Creació',
          field: 'data_creacio',
          type: 'date',
          sortable: true,
          dateInputFormat: 'yyyy-MM-dd k:m',
          dateOutputFormat: 'MMM d yyyy' // outputs Mar 16th 2018
        },
        {
          label: 'Espai',
          field: 'aula',
          type: 'string',
          width: '75px',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Aula' // placeholder for filter input
          }
        },
        {
          label: 'Gestors',
          field: 'gestors',
          sortable: false,
          width: '100px',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Prioritat',
          field: 'prioritat',
          html: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            filterDropdownItems: [],
            placeholder: 'Tots'
          }
        },
        {
          label: 'Estat',
          field: 'estat',
          type: 'string',
          sortable: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            filterDropdownItems: [],
            filterFn: this.filterState,
            placeholder: 'Tots'
          }
        }
      ]
    }
  }
}
</script>

<style scoped>
</style>
